import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { authApi } from '../../services/api';
import LoadingSpinner from '../LoadingSpinner';
import './EmailVerificationSection.css';

const EmailVerificationSection = () => {
  const { user } = useAuth();
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleResendVerification = async () => {
    setIsResending(true);
    setMessage({ type: '', text: '' });

    try {
      await authApi.resendVerification(user.email);
      setMessage({ 
        type: 'success', 
        text: 'Verification email sent! Please check your inbox and spam folder.' 
      });
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.error || 'Failed to resend verification email'
      });
    } finally {
      setIsResending(false);
    }
  };

  if (user?.emailVerified) {
    return (
      <div className="email-verification-section verified">
        <div className="verification-status">
          <div className="status-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </div>
          <div className="status-content">
            <h3>Email verified</h3>
            <p>Your email address has been successfully verified.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="email-verification-section unverified">
      <div className="verification-status">
        <div className="status-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <div className="status-content">
          <h3>Email not verified</h3>
          <p>
            Please verify your email address to access all features. 
            Check your inbox for the verification email.
          </p>
          
          {message.text && (
            <div className={`message message-${message.type}`}>
              {message.text}
            </div>
          )}
          
          <button
            onClick={handleResendVerification}
            disabled={isResending}
            className="resend-button"
          >
            {isResending ? (
              <>
                <LoadingSpinner size="small" />
                Sending...
              </>
            ) : (
              'Resend verification email'
            )}
          </button>
          
          <small className="verification-note">
            Verification links expire in 24 hours. If you don't see the email, check your spam folder.
          </small>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationSection;
